module.exports = __webpack_public_path__ + "img/type9.c3a0ad4d.png";